import { render, staticRenderFns } from "./BaseCheckMark.vue?vue&type=template&id=5403a764&scoped=true&"
var script = {}
import style0 from "./BaseCheckMark.vue?vue&type=style&index=0&id=5403a764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403a764",
  null
  
)

export default component.exports